import script from "./admin.vue?vue&type=script&setup=true&lang=js"
export * from "./admin.vue?vue&type=script&setup=true&lang=js"

import "./admin.vue?vue&type=style&index=0&id=7f0f9f5c&lang=less"

const __exports__ = script;

export default __exports__